import { rem } from 'polished';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  font-size: ${rem(13)};
  margin: 0 -0.5em;
  margin-top: 1rem;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const MsgWrapper = styled.div`
  max-width: 100%;
  flex-basis: 100%;
  ${({ theme }) => theme.media.sm`
    max-width: 50%;
    flex-basis: 50%;
  `};
  display: flex;
`;

const Msg = styled.div`
  padding: 1em;
  margin: 0.5em;
  border: 1px solid ${({ theme }) => theme.color.primary};
  border-radius: 4px;
  display: flex;
`;

const ExclMark = styled.div`
  font-size: 32px;
  font-weight: bold;
  margin: 0 1rem 0 0.5rem;
  color: ${({ theme }) => theme.color.primary};
`;

export const PaygateMessages = props => {
  const { messages } = props;
  return messages ? (
    <Wrapper>
      {messages.map((msg, idx) => (
        <MsgWrapper key={idx.toString()}>
          <Msg>
            <ExclMark>!</ExclMark>
            <div dangerouslySetInnerHTML={{ __html: msg.message }} />
          </Msg>
        </MsgWrapper>
      ))}
    </Wrapper>
  ) : null;
};

PaygateMessages.propTypes = {
  messages: PropTypes.arrayOf(
    PropTypes.shape({
      message: PropTypes.string,
    }),
  ).isRequired,
};

export default PaygateMessages;



// WEBPACK FOOTER //
// ./src/components/PaygateMessages/index.js